var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('bottom-sheet',{attrs:{"overlay":true,"click-to-close":true,"id":"deposit-bottom-sheet"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('deposit-content',{staticClass:"pt-0 px-4 pb-3",on:{"deposit-created":function($event){return _vm.$emit('deposit-created', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }